__webpack_require__.p = "https://commerce.nbcuni.com/public/widget/latest/";